const CmsDepartmentModuleEnum = Object.freeze({
    CHIANBANNER: 3,
    DEPARTMENTABOUT: 6,
    DEPARTMENTEMPLOYEES: 7,
    DEPARTMENTTREATMENTS: 8,
  });
  
  export default CmsDepartmentModuleEnum;